import { IconBox, IconProps } from '../IconBox';

const SaveIcon = (props: IconProps) => (
  <IconBox {...props}>
    <path d="M8.077 6.462V3h5.078l-.001 3.462a.231.231 0 0 1-.23.23H8.306a.23.23 0 0 1-.23-.23Zm12.452.166L17.372 3.47c-.302-.3-.71-.468-1.135-.471h-1.699v3.462a1.624 1.624 0 0 1-1.615 1.615H8.307a1.624 1.624 0 0 1-1.614-1.615V3H4.616c-.89.005-1.61.725-1.616 1.616v14.768c.005.89.725 1.61 1.616 1.616h2.077v-5.307c.004-.89.725-1.61 1.614-1.616h7.386c.89.005 1.61.725 1.614 1.616V21h2.077A1.625 1.625 0 0 0 21 19.384V7.764a1.626 1.626 0 0 0-.47-1.136Zm-4.836 8.834H8.307a.23.23 0 0 0-.23.23V21h7.847l-.001-5.307a.231.231 0 0 0-.23-.232Z" />
  </IconBox>
);

export default SaveIcon;
